import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-bireports',
  templateUrl: './power-bireports.component.html',
  styleUrls: ['./power-bireports.component.scss']
})
export class PowerBIReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
